// Generated by CoffeeScript 2.7.0
var DatetimePickerPopover;

import Popover from './popover.js';

import DateTimePicker from 'trunks/vue/admin/components/libs/date_time_picker.js';

export default DatetimePickerPopover = (function() {
  var DEFAULT_OPTIONS, ELEMENT_OPTIONS, INITIAL_PICKER_PROPS, PICKER_OPTIONS, POPOVER_OPTIONS, VIEW_TYPES;

  class DatetimePickerPopover {
    constructor(element, options = {}) {
      this.element = DomMaster.wrap(element);
      this.options = _.extend({}, DEFAULT_OPTIONS, _.pick(options, _.union(ELEMENT_OPTIONS, POPOVER_OPTIONS, PICKER_OPTIONS, INITIAL_PICKER_PROPS)));
      if (!_.isEmpty(this.options.initValue)) {
        this.options.initValue = Date.parseFromString(this.options.initValue);
      }
      this.viewType = this.options.viewType;
      this.__completePopoverHTML();
      this.__initPicker();
      this.__initEvents();
      this.__initPopover();
    }

    reset(value) {
      return this.datetime_picker.reset(value);
    }

    __initPopover() {
      return this.popover = new Popover(this.element, _.extend(_.pick(this.options, POPOVER_OPTIONS), {
        type: 'select'
      }));
    }

    __completePopoverHTML() {
      var content_el;
      content_el = this.element.find('.content');
      return content_el.html(_.template(`<div class='js-datetime-picker'></div>
<div class='popover-select-footer'>
  <div class='btn text-btn js-select-current-btn'>立即</div>
  <% if (modeChangeable) { %>
  <div class='btn text-btn js-switch-view-mode-btn'>
    <%= view_types[viewType] %>
  </div>
  <% } %>
  <div class='btn text-btn js-ensure-btn'>确认</div>
</div>`)(_.extend(_.pick(this.options, PICKER_OPTIONS), {
        view_types: VIEW_TYPES
      })));
    }

    __initPicker() {
      return this.datetime_picker = new DateTimePicker({
        el: this.element.find('.js-datetime-picker').node,
        propsData: _.pick(this.options, INITIAL_PICKER_PROPS)
      });
    }

    __initEvents() {
      this.element.node.proxy('click', '.js-select-current-btn', (event) => {
        return this.__selectCurrent();
      });
      this.element.node.proxy('click', '.js-switch-view-mode-btn', (event) => {
        return this.__switchViewMode(event);
      });
      return this.element.node.proxy('click', '.js-ensure-btn', (event) => {
        return this.__ensureClicked();
      });
    }

    __selectCurrent() {
      this.datetime_picker.setValue(new Date());
      return _.defer(() => {
        return this.__ensureClicked();
      });
    }

    __ensureClicked() {
      var base;
      this.value = this.datetime_picker.getValue();
      this.popover.close();
      return typeof (base = this.options).ensureCallback === "function" ? base.ensureCallback(this.value) : void 0;
    }

    __switchViewMode(event) {
      this.viewType = this.viewType === 'date' ? 'time' : 'date';
      DomMaster.wrap(event._target).html(VIEW_TYPES[this.viewType]);
      return this.datetime_picker.switchViewMode();
    }

  };

  DEFAULT_OPTIONS = {
    modeChangeable: true,
    viewType: 'date'
  };

  VIEW_TYPES = {
    date: '选时间',
    time: '选日期'
  };

  ELEMENT_OPTIONS = ['ensureCallback'];

  POPOVER_OPTIONS = ['beforeOpenFunc', 'beforeCloseFunc'];

  PICKER_OPTIONS = ['modeChangeable', 'viewType'];

  INITIAL_PICKER_PROPS = ['initValue', 'viewMode', 'limitEnd', 'limitStart'];

  return DatetimePickerPopover;

}).call(this);
